export default function runOnce(target, key, descriptor) {
  const originMethod = target[key];
  let hasBeenCalled = false;

  return {
    ...descriptor,
    value() {
      if (hasBeenCalled) {
        return;
      }
      hasBeenCalled = true;
      return originMethod.apply(this, arguments);
    },
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils/run-once.js